import {
  ReportDone5SAuditActionTypes,
  ReportDoneData,
  ReportDoneFilters,
  LoadRequestAction,
  LoadSuccessAction,
  LoadFailureAction,
} from '../../types/reportDone5SAudit';

export const loadReportDone = (filters: ReportDoneFilters): LoadRequestAction => ({
  type: ReportDone5SAuditActionTypes.LOAD_REQUEST,
  payload: { filters },
});

export const loadReportDoneSuccess = (data: ReportDoneData): LoadSuccessAction => ({
  type: ReportDone5SAuditActionTypes.LOAD_SUCCESS,
  payload: { data },
});

export const loadReportDoneFailure = (error: string): LoadFailureAction => ({
  type: ReportDone5SAuditActionTypes.LOAD_FAILURE,
  payload: { error },
});
